export enum LineItemMode {
  Default = 'default',
  Consolidated = 'consolidated',
  ConsolidatedBySku = 'consolidated-by-sku',
}
